import React from 'react'
import Page from '../page'

import HomePage from '../components/frontpage'
import SEO from '../components/seo'

class Component extends Page {
  onMountGlobalState(state) {
    return {
      ...state,
      whiteLogo: true,
    }
  }

  render() {
    return [
      <SEO
        {...this.props.data.frontpage}
        {...this.props.pathContext}
        key="seo"
      />,
      <HomePage data={this.props.data} />,
    ]
  }
}

export default Component

export const pageQuery = graphql`
  query FrontPageQuery($id: String!) {
    frontpage: wordpressPage(id: { eq: $id }) {
      ...FrontPageFragment
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/page-front.js